// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCssJs$PrezzeeRibbon from "../bindings/BsCss/BsCssJs.bs.js";

var family = BsCssJs$PrezzeeRibbon.fontFamilies([
      {
        NAME: "custom",
        VAL: "sofia-pro"
      },
      "sansSerif"
    ]);

var SofiaPro = {
  family: family
};

export {
  SofiaPro ,
}
/* family Not a pure module */
